<template>
    <transition name="fade">
        <div class="Video" v-show="videoVisible" @click="toggleVideo()">
            <div class="vf-container" @click="$event.stopPropagation()">
                
                <div class="vf-bar">
                    <p class="vf-bar-name" v-if="name">{{name}}</p>
                    <div class="vf-bar-buttons">  
                        <md-button class="md-icon-button" @click="toggleVideo()" style="margin-right: 0;">
                            <CloseIcon class="closeIcon"/>
                        </md-button>
                    </div> 
                </div>

                <video id="vf-video" autoplay class="vf-video" controls :src="videoURL"/>
            </div>
        </div>  
    </transition>
</template>

<style scoped>
    .Video{
        width: 100%;
        height: 100%; 
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #000000d0;
        z-index: 5;
    }
    .vf-container{
        margin-top: 40px;
        position: absolute;
        background: white;
        border-radius: 10px;
        transition: width .4s ease, height .4s ease;
        overflow: hidden;
        width: 88%;
        height: 88%;
    }
    .vf-bar{
        padding: 3px;
        padding-right: 5px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.774);
        display: flex;
        position: relative;
    }
    .vf-bar-name{
        width: 100%;
        text-align: center;
        font-size: 18px;
        margin: auto 0;
    }
    .vf-bar-buttons{
        margin-left: auto;
    }
    .vf-video{
        width: 100%;
        height: calc(100% - 46px);
        object-fit: contain;
        border-radius: 0px 0px 8px 8px;
    }
    .vf-controls{
        position: absolute;
        bottom: 0;
        opacity: 0;
        transition: .3s opacity ease-in-out;
        height: 70px;
        width: 100%;
        background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.788) 70%);
        border-radius: 0px 0px 9px 9px;
    }
    .vf-video:hover + .vf-controls{
        opacity: 1;
    }
    .vf-controls:hover{
        opacity: 1;
    }
    .vf-controls-button{
        border: none;
        background: transparent;
        border-radius: 5px;
        transition: .2s background ease;
        margin: 2px;
        cursor: pointer;
    }
    .vf-controls-button:hover{
        background: rgba(255, 255, 255, 0.1);
    }
    .vf-controls-button-image{
        width: 30px;
        height: 30px;
        margin: 2px;
    }
    .vf-controls-time{
        color: white;
        font-size: 16px;
        margin-left: 15px;
    }
    .vf-controls-slider{
        width: 98%;
        cursor: pointer;
        margin-left: 1%;
        margin-right: 1%;
    }
    .vf-controls-top{
        display: flex;
        align-items: center;
    }
    .md-button{
        background: transparent;
        padding: 0;
        width: 30px;
    }
    .material-design-icon.closeIcon {
        height: 2.5em;
        width: 2.5em;
    }
    .material-design-icon.closeIcon> .material-design-icon__svg {
        fill: rgb(252, 113, 113);
        height: 2.5em;
        width: 2.5em;
    }
</style>
    
<script>
import {mapMutations} from 'vuex';
import CloseIcon from 'vue-material-design-icons/Close.vue'

export default {
    components: {CloseIcon},
    data: function () {
        return {
            videoVisible: false,
            videoCurentTime: "0:00/0:00",
            paused: true,
            videoURL: null,
            name: null,
        }
    }, 
	methods: {
        ...mapMutations(['setDialogueOpen']),      
        toggleVideo(){
            this.videoVisible = !this.videoVisible;
            this.setDialogueOpen(this.videoVisible);
            if(!this.videoVisible)
                document.getElementsByClassName("vf-video")[0].pause();
        },
        initDialogue(e){
            this.videoURL = e.detail.videoURL;
            document.getElementById("vf-video").currentTime = e.detail.time;
            this.name = e.detail.name;
            this.toggleVideo();
        },
        playVideo(){
            let video = document.getElementById("vf-video");
            video.paused ? video.play() : video.pause();
        },
        changeTime(){
            let video = document.getElementById("vf-video");
            video.currentTime = document.getElementById("vf-slider").value;
        },
        formatTime(time) {
            var mins = Math.floor(time / 60);
            var secs = Math.floor(time - mins * 60);
            return mins + ":" + (secs < 10 ? "0" : "") + secs;
        },
    },
    mounted: function(){
        window.addEventListener('openVideo',this.initDialogue);
        
        let video = document.getElementById("vf-video");
        video.onloadedmetadata = () =>{
            this.paused = video.paused;
        };
        video.onplay = () =>{
            this.paused = false;
        }
        video.onpause = () =>{
            this.paused = true;
        }
    }
}
</script>